import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SearchBar() {
    const [searchInput, setSearchInput] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setSearchInput(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (searchInput.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchInput.trim())}`);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="search-bar">
            <input
                type="text"
                id = "searchbar"
                name = "searchbar"
                value={searchInput}
                onChange={handleChange}
                placeholder="Search recipes..."
            />
            <button type="submit">Search</button>
        </form>
    );
}

export default SearchBar;